module.exports = __webpack_public_path__ + "static/media/orig.893fbe3f.png";